import React, { useState } from "react";
import "./VipTabs.css";
import No_data from "../../Common/No_data/No_data";
import Rules_card from "../../Common/Common_Component/Rules_card/Rules_card";
import Vip_Rules from "./Vip_Rules/Vip_Rules";
import VipTabHistory from "./VipTabHistory/VipTabHistory";

// Ensure these components are imported correctly
// import Rules_card from "./Rules_card";
// import No_data from "./No_data";

function VipTabs() {
  const [active, setActive] = useState("history");

  return (
    <div className="vip_tabs">
      <div className="container">
        {/* Tab Header using your provided CSS classes */}
        <div className="tab_header">
          <span
            className={active === "history" ? "active" : ""}
            onClick={() => setActive("history")}
          >
            History
          </span>
          <span
            className={active === "rules" ? "active" : ""}
            onClick={() => setActive("rules")}
          >
            Rules
          </span>
        </div>

        {/* Tab Content */}
        <div className="tab_content">
          {active === "history" ? (
            < >
              <VipTabHistory />
              {/* <No_data /> */}
            </>
          ) : (
            <>
              {/* Rules Description Header */}
              <Vip_Rules />

              {/* No Data component at the bottom of rules if needed */}
              <No_data />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default VipTabs;
